export const buildHostedPublicRegistrationPath = (eventId: number | string, language = "hr"): string =>
    `/public/events/${encodeURIComponent(String(eventId))}/register?lang=${encodeURIComponent(language)}`;

export const buildHostedPublicRegistrationUrl = (
    origin: string,
    eventId: number | string,
    language = "hr"
): string => `${origin.replace(/\/+$/, "")}${buildHostedPublicRegistrationPath(eventId, language)}`;

export const withPublicRegistrationEmbedMode = (hostedUrl: string): string =>
    `${hostedUrl}${hostedUrl.includes("?") ? "&" : "?"}embed=1`;

const escapeHtmlAttribute = (value: string): string =>
    value.replace(/&/g, "&amp;").replace(/"/g, "&quot;");

export const buildPublicRegistrationIframeId = (eventId: number | string): string =>
    `eventflow-registration-${String(eventId).replace(/[^A-Za-z0-9_-]/g, "")}`;

// The listener only accepts height messages from the EventFlow origin and from this iframe's window.
export const buildHostedPublicRegistrationIframeSnippet = (
    hostedUrl: string,
    frameId = "eventflow-registration"
): string => {
    const src = escapeHtmlAttribute(withPublicRegistrationEmbedMode(hostedUrl));
    const eventFlowOrigin = new URL(hostedUrl).origin;

    return [
        `<iframe id="${escapeHtmlAttribute(frameId)}" src="${src}" title="EventFlow registration" width="100%" height="900" style="border:0;" loading="lazy"></iframe>`,
        "<script>",
        "(function () {",
        `  var frame = document.getElementById(${JSON.stringify(frameId)});`,
        `  var eventFlowOrigin = ${JSON.stringify(eventFlowOrigin)};`,
        "  window.addEventListener(\"message\", function (event) {",
        "    if (!frame || event.origin !== eventFlowOrigin || event.source !== frame.contentWindow) return;",
        "    var data = event.data;",
        "    if (!data || data.type !== \"eventflow:registration-height\") return;",
        "    var height = Number(data.height);",
        "    if (height > 0 && height < 100000) frame.style.height = Math.ceil(height) + \"px\";",
        "  });",
        "})();",
        "</script>"
    ].join("\n");
};
